export default function SolutionSection() {
  const features = [
    {
      icon: 'https://winka.io/wp-content/uploads/elementor/thumbs/graphic-5-rfjtkvlo2tqvzn10qhz5tt7xvljgmkejwtp2mtlhc0.webp',
      title: '수익 상승',
      description: '7년 동안 레알타드를 선택한 파트너사들의 수익 상승률은 780% 입니다'
    },
    {
      icon: 'https://winka.io/wp-content/uploads/elementor/thumbs/graphic-6-rfjtkvlo2tqvzn10qhz5tt7xvljgmkejwtp2mtlhc0.webp',
      title: '낮은 폐업률',
      description: '레알타드의 파트너사들 중 폐업률은 고작 0.7% 밖에 되지 않습니다'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="animate-fade-in">
            <img 
              src="https://winka.io/wp-content/uploads/2024/01/0_1-A.webp" 
              alt="Solution Overview"
              className="w-full h-auto rounded-2xl shadow-2xl"
            />
          </div>

          <div className="space-y-8 animate-fade-in-right">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                레알타드는 온라인 배팅 솔루션에 관한 모든 해결책을 제공합니다
              </h2>
              <p className="text-gray-600 leading-relaxed">
                레알타드의 토탈 배팅 솔루션은 스포츠 배팅, 온라인 카지노, 온라인 슬롯머신, 온라인 경마, 비트코인 배팅, 판타지 스포츠, 포커 솔루션, 풀오토 한국 가상계좌 시스템, 해외 결제 시스템, 갬블링 라이센스, 토토 마케팅, 토토 미니게임 & 슬롯 API, 버추어 스포츠 등을 포함합니다.
              </p>
            </div>

            <div className="space-y-6">
              {features.map((feature, index) => (
                <div 
                  key={index}
                  className="flex items-start space-x-4 p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300"
                >
                  <div className="flex-shrink-0 w-16 h-16">
                    <img 
                      src={feature.icon} 
                      alt={feature.title}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
                    <p className="text-gray-600">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
